import styled from 'styled-components'
import { Search } from 'styled-icons/octicons/Search'
import variables from '../../styles/variables'

export const ExampleSearchForm = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 350px;
  @media ${variables.media.sm} {
    margin: 0;
  }
`
export const SearchFormInputContainer = styled.div`
  display: flex;
  background: #FFFFFF;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #D6D6D6;
  border-radius: 50px;
  padding: 0.5rem 1rem;
`
export const SearchFormInput = styled.input`
  width: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  font-size: 0.8em;
  color: ${variables.colors.oracle.dark};

  @media only percy {
    visibility: hidden;
  }
`
export const SearchIcon = styled(Search)`
  width: 16px;
  height: 16px;
`

export const SearchFormResultContainer = styled.div`
  padding: 0 10px;
  font-size: 1rem;
`
export const Keyword = styled.span`
  font-weight: 600;
`
export const SearchResultHeader = styled.p`
  margin: 30px 0 10px 0;
`
export const SearchResultText = styled.p`
  margin: 0;
  color: #555;
  font-size: 0.95rem;
`
export const ResultNumber = styled.p`
  font-size: 0.7rem;
  color: #A0A0A0;
  text-align: right;
`
